import { useState, useEffect, useCallback } from 'react'
import type { Visit } from '../types'

interface UseVisitsOptions {
  source?: string
  event?: string
  seed?: string
  email?: string
  limit?: number
  offset?: number
}

export function useVisits(options: UseVisitsOptions = {}) {
  const [visits, setVisits] = useState<Visit[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchVisits = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const params = new URLSearchParams()
      if (options.source) params.set('source', options.source)
      if (options.event) params.set('event', options.event)
      if (options.seed) params.set('seed', options.seed)
      if (options.email) params.set('email', options.email)
      if (options.limit) params.set('limit', String(options.limit))
      if (options.offset) params.set('offset', String(options.offset))
      const qs = params.toString()
      const res = await fetch(`/api/audit/visits${qs ? `?${qs}` : ''}`)
      if (!res.ok) throw new Error('Failed to fetch visits')
      const data = await res.json()
      setVisits(data.visits || [])
      setTotal(data.total || 0)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unknown error')
    } finally {
      setLoading(false)
    }
  }, [options.source, options.event, options.seed, options.email, options.limit, options.offset])

  useEffect(() => {
    fetchVisits()
  }, [fetchVisits])

  return { visits, total, loading, error, refetch: fetchVisits }
}
